import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import * as ClientConstants from '../../../core/constants/client.constants';
import { ClientsService } from '../../../core/services/clients/clients.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFloppyDisk } from '@fortawesome/pro-solid-svg-icons';


@Component({
  selector: 'app-invoicing-form',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, DropdownModule, InputTextModule, InputTextareaModule, CheckboxModule, CalendarModule, AccordionModule, FontAwesomeModule],
  templateUrl: './invoicing-form.component.html',
  styleUrl: './invoicing-form.component.scss'
})
export class InvoicingFormComponent {

  public clientConstants = ClientConstants;

  @Input() clientId: any;
  @Output() formIsDirty = new EventEmitter<boolean>();
  @ViewChild('progressBar', { static: false }) progressBar!: ElementRef<HTMLProgressElement>;

  faFloppyDisk =faFloppyDisk

  invoicingForm = this.fb.group({
    paymentType: [''],
    paymentDays: [],
    invoicingStartDate: [],
    billFormat: [''],
    exemptionIVA: [false],
    exemptionTypeIVA: [''],
    iban1: [''],
    sepa: [null],
    feeProposalAccepted: [false],
    expedient: [''],
    periodicity: [''],
    fiscalFee: [],
    accountingFee: [],
    laboralFee: [],
    notificationsFee: [],
    domiciliationFee: [],
    booksFee: [],
    totalFee: [{ value: '', disabled: true }],
    // observations: [''],
    id: [],
    client: []
  });

  client: any;
  isSaved: boolean = false;

  bankAccounts: any;

  constructor(
    private fb: FormBuilder,
    private clientsService: ClientsService
    ) {
      this.invoicingForm.valueChanges.subscribe(() => {
        if (this.invoicingForm.dirty) {
          this.formIsDirty.emit(true);
        }
      });
     }
    
  async ngOnInit() {
    if (this.clientId) {
      let data = await this.clientsService.getClientInvoicing(this.clientId);
      this.client = await this.clientsService.getClientById(this.clientId);
      this.bankAccounts = (await this.clientsService.getClientBankAccounts(this.clientId)).filter((account: any) => account.endDate === null);

      if(data) {
          data.paymentDays = data.paymentDays ? new Date(data.paymentDays) : null;       
          data.invoicingStartDate = data.invoicingStartDate ? new Date(data.invoicingStartDate) : null;        
          data.expiration = data.expiration ? new Date(data.expiration) : null;       
          data.nextEmissionDate = data.nextEmissionDate ? new Date(data.nextEmissionDate) : null;        
          data.acceptationDate = data.acceptationDate ? new Date(data.acceptationDate) : null;
        this.invoicingForm.patchValue(data);
      }
     
    }
  }

  async save() {
    this.invoicingForm.value.client = Number(this.clientId);
    if (!this.invoicingForm.value.id) {
      delete this.invoicingForm.value['id'];
    }
    await this.clientsService.saveClientInvoicing(this.invoicingForm.value);
  }
}
